<template>
  <div>
    <v-row dense class="mx-1">
      <v-spacer/>
      <v-btn icon @click="onClickRefresh">
        <v-icon left>mdi-refresh</v-icon>
      </v-btn>
      <px-search-text label="Busque por um cliente" v-model="searchText"
                      style="max-width: 400px"
                      class="rounded-card"
        :on-search="emitChange"/>
    </v-row>
  </div>
</template>

<script>
export default {
  props: {
    onClickRefresh: {
      type: Function,
      required: true,
    },
  },
  methods: {
    emitChange() {
      this.$emit('change');
    },
  },
  data() {
    return {};
  },
  computed: {
    searchText: {
      get() {
        return this.$store.getters['listagemVendas/searchText'];
      },
      set(searchText) {
        this.$store.dispatch('listagemVendas/searchText', searchText);
      },
    },
  },
};
</script>
